module.exports = __webpack_public_path__ + "img/dey.598d9ae.png";